import { ConnectedUser } from '../../stores/types/connection';
import { Broadcast } from '../../stores/types/broadcasting';
import { OpentokSessionValue, RoomSessionValue } from '../../connection/health';

export enum ProbeStatus {
	/** Service answered and there is something to report. */
	Ok = 'ok',
	/** Service answered, but there is nothing here (no broadcast, no session yet). */
	Empty = 'empty',
	/** Service answered slowly, or answered with a partially failed payload. */
	Degraded = 'degraded',
	/** Service did not answer, or answered with an error status. */
	Error = 'error',
}

/** Latency above this is reported as degraded rather than ok. */
export const DEGRADED_LATENCY_MS = 2000;

export interface Probe<T> {
	status: ProbeStatus;
	/** Short human readable reason, shown when status is not Ok. */
	message?: string;
	httpStatus: number;
	latencyMs: number;
	data: T | null;
}

export interface RoomHealth {
	/** epoch ms the snapshot completed */
	fetchedAt: number;
	roomSession: Probe<RoomSessionValue>;
	opentok: Probe<OpentokSessionValue>;
	broadcast: Probe<Broadcast>;
	connectedUsers: Probe<ConnectedUser[]>;
}

export type ProbeKey = Exclude<keyof RoomHealth, 'fetchedAt'>;

export const PROBE_KEYS: ProbeKey[] = [
	'roomSession',
	'opentok',
	'broadcast',
	'connectedUsers',
];

/** Poll cadences offered in the dashboard header. 0 pauses polling. */
export const POLL_INTERVALS_MS = [2000, 5000, 15000, 0] as const;

export const DEFAULT_POLL_INTERVAL_MS = 5000;
